import React from 'react';
import ServiceListItem from '../ServiceListItem';
import JsxHelper from '../../Helpers/JsxHelper';
import LookupText from '../../Elements/LookupText';
import TabListTableCellWidthEnum from '../../Enums/TabListTableCellWidthEnum';

export default class InventoryAuditsServiceItem extends ServiceListItem {
  static FieldsToShowInListTable = [
    ...ServiceListItem.generalTab,
    {
      tabName: 'Fieldwork',
      tabLabel: 'Fieldwork',
      icon: 'fa-solid fa-briefcase',
      data: [
        { name: 'TimeConstraints', label: 'Visit Time Constraints (days/hours/etc)' },
        { name: (item) => Array.isArray(item.TypeOfStores) ? item.TypeOfStores.join(', ') : (item.TypeOfStores || ''), label: 'Type of Stores' },
        { name: 'Coverage', label: 'Coverage' },
        { name: 'EstimatedTimePerAudit', label: 'Estimated Time per Audit (in minutes)' },
        { name: (item) => Array.isArray(item.Tools) ? item.Tools.join(', ') : (item.Tools || ''), label: 'Tools' },
        { name: 'DataPoints', label: 'Data Points' },
        { name: 'AnnouncedOrUnannounced', label: 'Announced or Unannounced?' },
        { name: (item) => JsxHelper.YesNo(item.LetterOfAuthorizationRequired), label: 'Letter of Authorization Required?' },
        { name: (item) => <LookupText lookupId={21} value={item.DataCaptureMethodCode} />, label: 'Data Capture Method' },
        { name: 'OtherDataCaptureMethod', label: 'Other Data Capture Method Description' },
        { name: (item) => JsxHelper.YesNo(item.PhotosReqd), label: 'Photos Required?' },
        { name: 'PhotosDescription', label: 'Please Describe Photos Needed' },
        { name: (item) => JsxHelper.YesNo(item.CallingAheadRequired), label: 'Calling Ahead of Audit Required?' },
        { name: (item) => <LookupText lookupId={37} value={item.MaxDeliveryAfterShop} />, label: 'Time to Deliver Evaluation to Client' },
      ],
    },
    {
      tabName: 'LocationDetails',
      tabLabel: 'Location Details',
      icon: 'fa-solid fa-map-marker-alt',
      data: [
        { name: (item) => Array.isArray(item.SpecialLocations) ? item.SpecialLocations.join(', ') : (item.SpecialLocations || ''), label: 'Special Locations' },
        { name: (item) => Array.isArray(item.LocationType) ? item.LocationType.join(', ') : (item.LocationType || ''), label: 'Location Type' },
        { name: 'LocationTypeDetails', label: 'Location Type Details', width: TabListTableCellWidthEnum.TwoLines },
        { name: 'LocationListSource', label: 'Location List Source' },
      ],
    },
    ...ServiceListItem.commonEndTabs,
  ];
}
